import axios from "axios";
import React, { useState } from "react";
import { discountGroupObjects } from "./data";
import { GlobalState } from "context/GlobalContext";
import ApplicableDate from "./ApplicableDateSection/ApplicableDate";
import DiscountValueSection from "./DiscountValueSection/DiscountValueSection";
import { Box, Button, Step, StepLabel, Stepper, Typography } from "@mui/material";
import MasterGeneralInformation from "./MasterGeneralInformation/MasterGeneralInformation";
import ProductSelectionSection from "./ProductSelectionSection/ProductSelectionSection";
import StoreAvailabilitySection from "./StoreAvailabilitySection/StoreAvailabilitySection";

const steps = [
	{ label: "General Information", component: MasterGeneralInformation, key: discountGroupObjects.general_information.key },
	{ label: "Applicable Date", component: ApplicableDate, key: discountGroupObjects.applicable_date.key },
	{ label: "Store Availability", component: StoreAvailabilitySection, key: discountGroupObjects.store_availability.key },
	{ label: "Discount Value", component: DiscountValueSection, key: discountGroupObjects.discount_value.key },
	{ label: "Product Selection", component: ProductSelectionSection, key: discountGroupObjects.product_selection.key },
];

function DiscountMaster() {
	const initial_state = {
		[discountGroupObjects.general_information.key]: {
			scheme_type: "",
			scheme_name: "",
			brand: "",
			scheme_description: "",
		},
		[discountGroupObjects.applicable_date.key]: {
			start_date: "",
			end_date: "",
			applicable_days: [],
		},
		[discountGroupObjects.store_availability.key]: {
			region: [],
			store: [],
			distributer: [],
			state: [],
			city: [],
		},
		[discountGroupObjects.discount_value.key]: [],
		[discountGroupObjects.product_selection.key]: {
			discount_product: [],
			nod: [],
		},
	};

	const [value, setValue] = useState(initial_state);
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();

	const handleSubmit = async () => {
		setLoadingOpen(true);
		try {
			const res = await axios.post("/api/mbo_payment_working/save_discount_details", value);
			if (res.status === 201) {
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Discount Scheme created successfully",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setValue(initial_state);
			}
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Failed to create scheme ${error}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setValue(initial_state);
		} finally {
			setLoadingOpen(false);
		}
	};

	return (
		<Box width="100%" pt={4}>
			<Stepper orientation="vertical">
				{steps.map((step, index) => {
					const StepComponent = step.component;
					return (
						<Step key={index} expanded>
							<StepLabel>{step.label}</StepLabel>
							<Box mt={2} mb={4}>
								<StepComponent value={value} setValue={setValue} />
							</Box>
						</Step>
					);
				})}
			</Stepper>

			<Box mt={4} display="flex" justifyContent="flex-end">
				<Button variant="contained" onClick={handleSubmit}>
					Submit
				</Button>
			</Box>
		</Box>
	);
}

export default DiscountMaster;
